import AppSettings from "AppSettings";
import { OdooContext } from "OdooProvider";
import { useContext } from "react";
import { Link } from "react-router-dom";

const ProductLinksView = ({ product }) => {
  const { odooUrl, odooUrlInc } = useContext(OdooContext);
  const companies = Object.entries(AppSettings.odooCompanies)
    .filter(([company, _]) =>
      product.company === "UNSET" ? true : company === product.company,
    )
    .map(([company, companyId]) => ({
      id: companyId,
      name: company,
    }));

  return (
    <div className="space-x-2">
      <Link to={`/manage/products?id=${product.id}`} target="_blank">
        [{product.number}] {product.name}
      </Link>

      {product.odooId &&
        companies.map((i) => (
          <a
            key={i.id}
            className="text-purple-600 dark:text-purple-700"
            href={`${odooUrl}/odoo/action-563/${product.odooId}?cids=${i.id}`}
            target="_blank"
            rel="noreferer"
          >
            Odoo {i.name}
          </a>
        ))}

      {product.odooIdInc && (
        <a
          className="text-purple-600 dark:text-purple-700"
          href={`${odooUrlInc}/odoo/action-195/${product.odooIdInc}`}
          target="_blank"
          rel="noreferer"
        >
          Odoo INC
        </a>
      )}
    </div>
  );
};

export default ProductLinksView;
